var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/16px/delete2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,2.9905 L14.5,2.9905 C14.7765,2.9905 15,3.2145 15,3.4905 C15,3.7665 14.7765,3.9905 14.5,3.9905 L13.5,3.9905 L13.5,14.748 C13.5,15.4385 12.9385,16 12.248,16 L3.752,16 C3.062,16 2.5,15.4385 2.5,14.748 L2.5,3.9905 L1.5,3.9905 C1.224,3.9905 1,3.7665 1,3.4905 C1,3.2145 1.224,2.9905 1.5,2.9905 L5.5,2.9905 L5.5,2.5 C5.5,1.1215 6.6215,0 8,0 C9.3785,0 10.5,1.1215 10.5,2.5 L10.5,2.9905 Z M9.5,2.9905 L9.5,2.5 C9.5,1.673 8.827,1 8,1 C7.173,1 6.5,1.673 6.5,2.5 L6.5,2.9905 L9.5,2.9905 Z M3.5,3.9905 L3.5,14.748 C3.5,14.887 3.613,15 3.752,15 L12.248,15 C12.387,15 12.5,14.887 12.5,14.748 L12.5,3.9905 L3.5,3.9905 Z M5.5,12.9905 C5.224,12.9905 5,12.767 5,12.4905 L5,6.4905 C5,6.2145 5.224,5.9905 5.5,5.9905 C5.776,5.9905 6,6.2145 6,6.4905 L6,12.4905 C6,12.767 5.776,12.9905 5.5,12.9905 Z M10.5,12.9905 C10.2235,12.9905 10,12.767 10,12.4905 L10,6.4905 C10,6.2145 10.2235,5.9905 10.5,5.9905 C10.7765,5.9905 11,6.2145 11,6.4905 L11,12.4905 C11,12.767 10.7765,12.9905 10.5,12.9905 Z M8,13.4905 C7.724,13.4905 7.5,13.267 7.5,12.9905 L7.5,5.9905 C7.5,5.7145 7.724,5.4905 8,5.4905 C8.276,5.4905 8.5,5.7145 8.5,5.9905 L8.5,12.9905 C8.5,13.267 8.276,13.4905 8,13.4905 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/delete2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "delete-icon",
    fill: "#c0c8cf",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlack);
export default __webpack_public_path__ + "static/media/delete-black.25e1cfb93794050eb863eeaff62a1204.svg";
export { ForwardRef as ReactComponent };